import React, { useId } from 'react';

/**
 * A labelled input in a search panel. `group`: for a field with several buttons (a multi-select's
 * remove buttons) - a <label> passes a click on its text or an option on to its first button.
 */
export function SearchField({ label, children, className = '', group = false }) {
  const labelId = useId();
  const Tag = group ? 'div' : 'label';
  return (
    <Tag className={`flex flex-col gap-1 ${className}`} {...(group && { role: 'group', 'aria-labelledby': labelId })}>
      <span id={labelId} className="text-xs font-medium text-gray-600 dark:text-gray-300">{label}</span>
      {children}
    </Tag>
  );
}

/**
 * The frame shared by every search panel: the fields (children), then a footer with optional
 * content on the left (footerStart) and the "Reset filters" button on the right.
 */
export default function SearchPanel({ children, footerStart = null, onReset, resetDisabled = false }) {
  return (
    <div className="mb-4 rounded-lg border border-gray-200 bg-white p-3 shadow-sm dark:border-gray-700 dark:bg-gray-800">
      {children}

      <div className="mt-3 flex items-center justify-between gap-2">
        {/* An empty placeholder keeps "Reset filters" on the right */}
        {footerStart ?? <span />}
        <button
          type="button"
          onClick={onReset}
          disabled={resetDisabled}
          className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
        >
          Reset filters
        </button>
      </div>
    </div>
  );
}
